export enum RoleTypeNames {
  ADMIN = 'admin',
  COORDINATOR = 'koordynator',
  EXPERT = 'ekspert',
  PARTNER = 'partner',
  VERIFIER = 'weryfikator',
}
